import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../../app/hooks";
import { NameIdOption } from "../../../common/types/commonTypes";
import { fetchTesForBulkSalaryTableIncrease } from "../../tesSalaryTables/tesSalaryTablesApi";

/**
 * Loads TES ids that have salary tables enabled and enough published tables for bulk table work; maps labels from `state.localized.tes`.
 */
const useEligibleTesForBulkSalaryTableIncrease = (enabled: boolean) => {
  const tesLabels = useAppSelector((state) => state.localized.tes);
  const [ids, setIds] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const options: NameIdOption[] = useMemo(
    () =>
      ids.map((id) => ({
        id,
        name: tesLabels[id] || id,
      })),
    [ids, tesLabels],
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }
    let cancelled = false;
    setLoading(true);
    fetchTesForBulkSalaryTableIncrease()
      .then((data) => {
        if (!cancelled) {
          setIds(data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIds([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { options, loading };
};

export default useEligibleTesForBulkSalaryTableIncrease;
